import React from 'react';
import CourseList from '../components/CourseList';
import { useTheme } from '../contexts/ThemeContext';

const CoursesPage: React.FC = () => {
  const { colors } = useTheme();
  
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 relative inline-block" style={{ color: colors.text.primary }}>
          Available Courses
          <span 
            className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2/3 h-1 rounded-full"
            style={{
              background: `linear-gradient(90deg, ${colors.primary.main} 0%, ${colors.accent.mint} 100%)`
            }}
          ></span>
        </h1>
        <p className="text-lg max-w-2xl mx-auto mt-6" style={{ color: colors.text.secondary }}>
          Explore our wide range of courses designed to help you achieve your learning goals.
          Browse through our catalog and find the perfect course for you.
        </p>
      </div>
      <CourseList />
    </div>
  );
};

export default CoursesPage;
    